<app-loading-spinner *ngIf="appService.isLoading"></app-loading-spinner>
<div class="signin-area">
  <img class="sign-bg" src="../../../assets/images/signin_bg.jpg">
  <div class="bg-area"></div>
</div>